import React from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const PrintButton = ({ DomIdPrint, success, formRef, toggleComponentVisibility }) => {
  const handlePrint = async () => {
    try {
      toggleComponentVisibility(true);

      await new Promise((resolve) => setTimeout(resolve, 1000));

      const formElement = formRef.current;

      const canvas = await html2canvas(formElement, {
        scale: 1,
        useCORS: true,
        logging: false,
        onclone: (clonedDoc) => {
          // Strip all background-image (includes linear-gradient) to avoid the
          // "addColorStop: non-finite value" crash when zero-size elements have
          // gradient backgrounds set by the material component stylesheet.
          const style = clonedDoc.createElement("style");
          style.textContent = "* { background-image: none !important; }";
          clonedDoc.head.appendChild(style);
        },
      });

      toggleComponentVisibility(false);

      const imgData = canvas.toDataURL("image/png");
      const pdfWidth = 210;
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      const pdf = new jsPDF("p", "mm", [210, pdfHeight + 20]);
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("formulario.pdf");
    } catch (error) {
      toggleComponentVisibility(false);
      console.error("Error al generar PDF:", error);
    }
  };

  return (
    <button className="btn-box btn-accent" onClick={handlePrint} disabled={success}>
      Imprimir
    </button>
  );
};

export default PrintButton;
